// @generated by protoc-gen-es v1.10.0
// @generated from file omnios/v1/catalog.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Struct, Timestamp } from "@bufbuild/protobuf";
import { FilterGroup, PageRequest, PageResponse, SortSpec } from "./common_pb.js";

/**
 * @generated from enum omnios.v1.ImportDestination
 */
export const ImportDestination = /*@__PURE__*/ proto3.makeEnum(
  "omnios.v1.ImportDestination",
  [
    {no: 0, name: "IMPORT_DESTINATION_OWN_CATALOG", localName: "OWN_CATALOG"},
    {no: 1, name: "IMPORT_DESTINATION_COMPETITOR", localName: "COMPETITOR"},
    {no: 2, name: "IMPORT_DESTINATION_SUPPLIER", localName: "SUPPLIER"},
  ],
);

/**
 * @generated from message omnios.v1.Product
 */
export const Product = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.Product",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "is_draft", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "is_bundle", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "pricing", kind: "message", T: ProductPrice, repeated: true },
    { no: 11, name: "properties", kind: "message", T: Struct },
    { no: 12, name: "vendor_codes", kind: "message", T: VendorCode, repeated: true },
    { no: 13, name: "dimensions", kind: "message", T: ProductDimensions },
    { no: 14, name: "availability", kind: "message", T: Struct },
    { no: 20, name: "category_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 21, name: "tag_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 22, name: "media_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 25, name: "quality_score", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 26, name: "enrichment_version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 27, name: "status_config_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 28, name: "status_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 29, name: "status_color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 33, name: "publish_at", kind: "message", T: Timestamp },
    { no: 34, name: "unpublish_at", kind: "message", T: Timestamp },
    { no: 30, name: "created_at", kind: "message", T: Timestamp },
    { no: 31, name: "updated_at", kind: "message", T: Timestamp },
    { no: 32, name: "deleted_at", kind: "message", T: Timestamp },
    { no: 40, name: "parent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 41, name: "is_variant", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 42, name: "variant_position", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 43, name: "variation_axes", kind: "message", T: VariationAxis, repeated: true },
    { no: 44, name: "variants", kind: "message", T: Product, repeated: true },
    { no: 45, name: "variant_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 50, name: "owner_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 51, name: "is_external", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 55, name: "seo_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 56, name: "seo_description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 57, name: "supplier_cost_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 58, name: "supplier_cost_currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ProductPrice
 */
export const ProductPrice = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ProductPrice",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "value_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "is_default", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "vat_rate", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "vat_sum", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "region", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.VendorCode
 */
export const VendorCode = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.VendorCode",
  () => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "is_default", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.ProductDimensions
 */
export const ProductDimensions = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ProductDimensions",
  () => [
    { no: 1, name: "height_mm", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "width_mm", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "length_mm", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "weight_g", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message omnios.v1.ProductCategory
 */
export const ProductCategory = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ProductCategory",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "parent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "attrs", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.ProductGroup
 */
export const ProductGroup = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ProductGroup",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "product_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "tag_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.VariationAxis
 */
export const VariationAxis = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.VariationAxis",
  () => [
    { no: 1, name: "property_definition_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "property_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "property_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "value_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "unit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "allowed_values", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.PropertyDefinition
 */
export const PropertyDefinition = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PropertyDefinition",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "value_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "unit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "is_filterable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "is_required", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "allowed_values", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: "created_at", kind: "message", T: Timestamp },
    { no: 11, name: "group_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "group_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.PropertyDefinitionGroup
 */
export const PropertyDefinitionGroup = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PropertyDefinitionGroup",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.CategoryPropertyLink
 */
export const CategoryPropertyLink = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CategoryPropertyLink",
  () => [
    { no: 1, name: "category_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "property_definition_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "is_required", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "inherited", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "source_category_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "source_category_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.WarehouseStock
 */
export const WarehouseStock = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.WarehouseStock",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "warehouse_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "quantity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "reserved_quantity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message omnios.v1.CreateProductRequest
 */
export const CreateProductRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateProductRequest",
  () => [
    { no: 1, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "is_draft", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "is_bundle", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "pricing", kind: "message", T: ProductPrice, repeated: true },
    { no: 6, name: "properties", kind: "message", T: Struct },
    { no: 7, name: "vendor_codes", kind: "message", T: VendorCode, repeated: true },
    { no: 8, name: "dimensions", kind: "message", T: ProductDimensions },
    { no: 9, name: "category_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: "tag_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 11, name: "status_config_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "publish_at", kind: "message", T: Timestamp },
    { no: 13, name: "unpublish_at", kind: "message", T: Timestamp },
    { no: 14, name: "owner_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetProductRequest
 */
export const GetProductRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetProductRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "include_variants", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.UpdateProductRequest
 */
export const UpdateProductRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateProductRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "is_draft", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 5, name: "pricing", kind: "message", T: ProductPrice, repeated: true },
    { no: 6, name: "properties", kind: "message", T: Struct },
    { no: 7, name: "vendor_codes", kind: "message", T: VendorCode, repeated: true },
    { no: 8, name: "dimensions", kind: "message", T: ProductDimensions },
    { no: 9, name: "category_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: "media_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 11, name: "status_config_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 12, name: "publish_at", kind: "message", T: Timestamp, opt: true },
    { no: 13, name: "unpublish_at", kind: "message", T: Timestamp, opt: true },
    { no: 14, name: "seo_title", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 15, name: "seo_description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 16, name: "owner_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.DeleteProductRequest
 */
export const DeleteProductRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteProductRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListProductsRequest
 */
export const ListProductsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListProductsRequest",
  () => [
    { no: 1, name: "page", kind: "message", T: PageRequest },
    { no: 2, name: "filter", kind: "message", T: FilterGroup },
    { no: 3, name: "sort", kind: "message", T: SortSpec },
    { no: 4, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "category_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "tag_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "exclude_variants", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "parent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "owner_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListProductsResponse
 */
export const ListProductsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListProductsResponse",
  () => [
    { no: 1, name: "products", kind: "message", T: Product, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.ImportProductRequest
 */
export const ImportProductRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ImportProductRequest",
  () => [
    { no: 1, name: "product", kind: "message", T: Product },
  ],
);

/**
 * @generated from message omnios.v1.ImportProductResponse
 */
export const ImportProductResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ImportProductResponse",
  () => [
    { no: 1, name: "created", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "updated", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "errors", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.CreateCategoryRequest
 */
export const CreateCategoryRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateCategoryRequest",
  () => [
    { no: 1, name: "parent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "attrs", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.UpdateCategoryRequest
 */
export const UpdateCategoryRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateCategoryRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.DeleteCategoryRequest
 */
export const DeleteCategoryRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteCategoryRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListCategoriesRequest
 */
export const ListCategoriesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListCategoriesRequest",
  () => [
    { no: 1, name: "parent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListCategoriesResponse
 */
export const ListCategoriesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListCategoriesResponse",
  () => [
    { no: 1, name: "categories", kind: "message", T: ProductCategory, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.DeleteAllProductsRequest
 */
export const DeleteAllProductsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteAllProductsRequest",
  [],
);

/**
 * @generated from message omnios.v1.DeleteAllProductsResponse
 */
export const DeleteAllProductsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteAllProductsResponse",
  () => [
    { no: 1, name: "deleted", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.DeleteAllCategoriesRequest
 */
export const DeleteAllCategoriesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteAllCategoriesRequest",
  [],
);

/**
 * @generated from message omnios.v1.DeleteAllCategoriesResponse
 */
export const DeleteAllCategoriesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteAllCategoriesResponse",
  () => [
    { no: 1, name: "deleted", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.BulkUpdateProductsRequest
 */
export const BulkUpdateProductsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BulkUpdateProductsRequest",
  () => [
    { no: 1, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "is_draft", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 3, name: "add_category_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "remove_category_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "delete", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.BulkUpdateProductsResponse
 */
export const BulkUpdateProductsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BulkUpdateProductsResponse",
  () => [
    { no: 1, name: "affected", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.MoveCategoryRequest
 */
export const MoveCategoryRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.MoveCategoryRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "new_parent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CreateVariantRequest
 */
export const CreateVariantRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateVariantRequest",
  () => [
    { no: 1, name: "parent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "pricing", kind: "message", T: ProductPrice, repeated: true },
    { no: 4, name: "properties", kind: "message", T: Struct },
    { no: 5, name: "vendor_codes", kind: "message", T: VendorCode, repeated: true },
    { no: 6, name: "dimensions", kind: "message", T: ProductDimensions },
  ],
);

/**
 * @generated from message omnios.v1.SetVariationAxesRequest
 */
export const SetVariationAxesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SetVariationAxesRequest",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "property_definition_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.SetVariationAxesResponse
 */
export const SetVariationAxesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SetVariationAxesResponse",
  () => [
    { no: 1, name: "axes", kind: "message", T: VariationAxis, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.ListVariantsRequest
 */
export const ListVariantsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListVariantsRequest",
  () => [
    { no: 1, name: "parent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListVariantsResponse
 */
export const ListVariantsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListVariantsResponse",
  () => [
    { no: 1, name: "variants", kind: "message", T: Product, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.GroupProductsRequest
 */
export const GroupProductsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GroupProductsRequest",
  () => [
    { no: 1, name: "parent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "variant_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "axis_property_definition_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.GroupProductsResponse
 */
export const GroupProductsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GroupProductsResponse",
  () => [
    { no: 1, name: "parent", kind: "message", T: Product },
  ],
);

/**
 * @generated from message omnios.v1.UngroupProductRequest
 */
export const UngroupProductRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UngroupProductRequest",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.SuggestVariationGroupsRequest
 */
export const SuggestVariationGroupsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SuggestVariationGroupsRequest",
  () => [
    { no: 1, name: "category_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.VariationGroupSuggestion
 */
export const VariationGroupSuggestion = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.VariationGroupSuggestion",
  () => [
    { no: 1, name: "base_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "axis_property_slugs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "product_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "confidence", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ],
);

/**
 * @generated from message omnios.v1.SuggestVariationGroupsResponse
 */
export const SuggestVariationGroupsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SuggestVariationGroupsResponse",
  () => [
    { no: 1, name: "suggestions", kind: "message", T: VariationGroupSuggestion, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.CreatePropertyGroupRequest
 */
export const CreatePropertyGroupRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreatePropertyGroupRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.ListPropertyGroupsRequest
 */
export const ListPropertyGroupsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListPropertyGroupsRequest",
  [],
);

/**
 * @generated from message omnios.v1.ListPropertyGroupsResponse
 */
export const ListPropertyGroupsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListPropertyGroupsResponse",
  () => [
    { no: 1, name: "groups", kind: "message", T: PropertyDefinitionGroup, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.DeletePropertyGroupRequest
 */
export const DeletePropertyGroupRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeletePropertyGroupRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.BulkSetPropertiesRequest
 */
export const BulkSetPropertiesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BulkSetPropertiesRequest",
  () => [
    { no: 1, name: "product_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "properties", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.BulkSetPropertiesResponse
 */
export const BulkSetPropertiesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BulkSetPropertiesResponse",
  () => [
    { no: 1, name: "affected", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.ExportProductsExcelRequest
 */
export const ExportProductsExcelRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ExportProductsExcelRequest",
  () => [
    { no: 1, name: "category_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "property_slugs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "owner_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ExportProductsExcelResponse
 */
export const ExportProductsExcelResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ExportProductsExcelResponse",
  () => [
    { no: 1, name: "download_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "expires_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "product_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.ImportProductsExcelRequest
 */
export const ImportProductsExcelRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ImportProductsExcelRequest",
  () => [
    { no: 1, name: "data", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 2, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "create_missing", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.ImportProductsExcelResponse
 */
export const ImportProductsExcelResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ImportProductsExcelResponse",
  () => [
    { no: 1, name: "created", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "updated", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "skipped", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "errors", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.GetProductVersionsRequest
 */
export const GetProductVersionsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetProductVersionsRequest",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.ProductVersion
 */
export const ProductVersion = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ProductVersion",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "snapshot", kind: "message", T: Struct },
    { no: 4, name: "changed_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "change_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.GetProductVersionsResponse
 */
export const GetProductVersionsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetProductVersionsResponse",
  () => [
    { no: 1, name: "versions", kind: "message", T: ProductVersion, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.RestoreProductVersionRequest
 */
export const RestoreProductVersionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RestoreProductVersionRequest",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.SalesChannel
 */
export const SalesChannel = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SalesChannel",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "icon", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "config", kind: "message", T: Struct },
    { no: 9, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.CreateSalesChannelRequest
 */
export const CreateSalesChannelRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateSalesChannelRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "icon", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "config", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.UpdateSalesChannelRequest
 */
export const UpdateSalesChannelRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateSalesChannelRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "icon", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "color", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 6, name: "config", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.DeleteSalesChannelRequest
 */
export const DeleteSalesChannelRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteSalesChannelRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListSalesChannelsRequest
 */
export const ListSalesChannelsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListSalesChannelsRequest",
  [],
);

/**
 * @generated from message omnios.v1.ListSalesChannelsResponse
 */
export const ListSalesChannelsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListSalesChannelsResponse",
  () => [
    { no: 1, name: "channels", kind: "message", T: SalesChannel, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.ChannelAttributeMapping
 */
export const ChannelAttributeMapping = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ChannelAttributeMapping",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "sales_channel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "source_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "source_value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "target_field", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "transform", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "is_required", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.SetChannelMappingsRequest
 */
export const SetChannelMappingsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SetChannelMappingsRequest",
  () => [
    { no: 1, name: "sales_channel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "mappings", kind: "message", T: ChannelAttributeMapping, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.SetChannelMappingsResponse
 */
export const SetChannelMappingsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SetChannelMappingsResponse",
  () => [
    { no: 1, name: "count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.ListChannelMappingsRequest
 */
export const ListChannelMappingsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListChannelMappingsRequest",
  () => [
    { no: 1, name: "sales_channel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListChannelMappingsResponse
 */
export const ListChannelMappingsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListChannelMappingsResponse",
  () => [
    { no: 1, name: "mappings", kind: "message", T: ChannelAttributeMapping, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.ExportToChannelRequest
 */
export const ExportToChannelRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ExportToChannelRequest",
  () => [
    { no: 1, name: "sales_channel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "product_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.ExportToChannelResponse
 */
export const ExportToChannelResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ExportToChannelResponse",
  () => [
    { no: 1, name: "run_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "products_queued", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.GetCatalogCompletenessRequest
 */
export const GetCatalogCompletenessRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetCatalogCompletenessRequest",
  () => [
    { no: 1, name: "category_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CategoryCompleteness
 */
export const CategoryCompleteness = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CategoryCompleteness",
  () => [
    { no: 1, name: "category_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "category_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "category_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "total_products", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "fully_filled", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "fill_rate_pct", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "fields", kind: "message", T: FieldCompleteness, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.FieldCompleteness
 */
export const FieldCompleteness = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.FieldCompleteness",
  () => [
    { no: 1, name: "property_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "property_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "is_required", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "filled_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "fill_rate_pct", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message omnios.v1.GetCatalogCompletenessResponse
 */
export const GetCatalogCompletenessResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetCatalogCompletenessResponse",
  () => [
    { no: 1, name: "categories", kind: "message", T: CategoryCompleteness, repeated: true },
    { no: 2, name: "overall_fill_rate_pct", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "total_products", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.ProductLocale
 */
export const ProductLocale = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ProductLocale",
  () => [
    { no: 1, name: "locale", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "properties", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.SetProductLocaleRequest
 */
export const SetProductLocaleRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SetProductLocaleRequest",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "locale", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "properties", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.ListProductLocalesRequest
 */
export const ListProductLocalesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListProductLocalesRequest",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListProductLocalesResponse
 */
export const ListProductLocalesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListProductLocalesResponse",
  () => [
    { no: 1, name: "locales", kind: "message", T: ProductLocale, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.DeleteProductLocaleRequest
 */
export const DeleteProductLocaleRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteProductLocaleRequest",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "locale", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.SupplierProductDraft
 */
export const SupplierProductDraft = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SupplierProductDraft",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "supplier_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "pricing", kind: "message", T: ProductPrice, repeated: true },
    { no: 7, name: "properties", kind: "message", T: Struct },
    { no: 8, name: "vendor_codes", kind: "message", T: VendorCode, repeated: true },
    { no: 9, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "reviewer_notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "created_at", kind: "message", T: Timestamp },
    { no: 21, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.CreateSupplierDraftRequest
 */
export const CreateSupplierDraftRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateSupplierDraftRequest",
  () => [
    { no: 1, name: "supplier_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "pricing", kind: "message", T: ProductPrice, repeated: true },
    { no: 5, name: "properties", kind: "message", T: Struct },
    { no: 6, name: "vendor_codes", kind: "message", T: VendorCode, repeated: true },
    { no: 7, name: "category_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.ListSupplierDraftsRequest
 */
export const ListSupplierDraftsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListSupplierDraftsRequest",
  () => [
    { no: 1, name: "supplier_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "page", kind: "message", T: PageRequest },
  ],
);

/**
 * @generated from message omnios.v1.ListSupplierDraftsResponse
 */
export const ListSupplierDraftsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListSupplierDraftsResponse",
  () => [
    { no: 1, name: "drafts", kind: "message", T: SupplierProductDraft, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.ReviewSupplierDraftRequest
 */
export const ReviewSupplierDraftRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ReviewSupplierDraftRequest",
  () => [
    { no: 1, name: "draft_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "action", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ReviewSupplierDraftResponse
 */
export const ReviewSupplierDraftResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ReviewSupplierDraftResponse",
  () => [
    { no: 1, name: "draft", kind: "message", T: SupplierProductDraft },
    { no: 2, name: "product", kind: "message", T: Product },
  ],
);

/**
 * @generated from message omnios.v1.FieldPermission
 */
export const FieldPermission = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.FieldPermission",
  () => [
    { no: 1, name: "role_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "resource", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "field_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "can_read", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "can_write", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.SetFieldPermissionsRequest
 */
export const SetFieldPermissionsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SetFieldPermissionsRequest",
  () => [
    { no: 1, name: "role_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "resource", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "permissions", kind: "message", T: FieldPermission, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.SetFieldPermissionsResponse
 */
export const SetFieldPermissionsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SetFieldPermissionsResponse",
  () => [
    { no: 1, name: "count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.GetFieldPermissionsRequest
 */
export const GetFieldPermissionsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetFieldPermissionsRequest",
  () => [
    { no: 1, name: "role_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "resource", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetFieldPermissionsResponse
 */
export const GetFieldPermissionsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetFieldPermissionsResponse",
  () => [
    { no: 1, name: "permissions", kind: "message", T: FieldPermission, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.ClassificationStandard
 */
export const ClassificationStandard = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ClassificationStandard",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.ClassificationCode
 */
export const ClassificationCode = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ClassificationCode",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "standard_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "parent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "level", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListClassificationStandardsRequest
 */
export const ListClassificationStandardsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListClassificationStandardsRequest",
  [],
);

/**
 * @generated from message omnios.v1.ListClassificationStandardsResponse
 */
export const ListClassificationStandardsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListClassificationStandardsResponse",
  () => [
    { no: 1, name: "standards", kind: "message", T: ClassificationStandard, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.ListClassificationCodesRequest
 */
export const ListClassificationCodesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListClassificationCodesRequest",
  () => [
    { no: 1, name: "standard_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "parent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListClassificationCodesResponse
 */
export const ListClassificationCodesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListClassificationCodesResponse",
  () => [
    { no: 1, name: "codes", kind: "message", T: ClassificationCode, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.SetProductClassificationsRequest
 */
export const SetProductClassificationsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SetProductClassificationsRequest",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "code_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.SetProductClassificationsResponse
 */
export const SetProductClassificationsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SetProductClassificationsResponse",
  () => [
    { no: 1, name: "count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.BundleItem
 */
export const BundleItem = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BundleItem",
  () => [
    { no: 1, name: "component_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "component_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "quantity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.SetBundleItemsRequest
 */
export const SetBundleItemsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SetBundleItemsRequest",
  () => [
    { no: 1, name: "bundle_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "items", kind: "message", T: BundleItem, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.SetBundleItemsResponse
 */
export const SetBundleItemsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SetBundleItemsResponse",
  () => [
    { no: 1, name: "count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.ListBundleItemsRequest
 */
export const ListBundleItemsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListBundleItemsRequest",
  () => [
    { no: 1, name: "bundle_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListBundleItemsResponse
 */
export const ListBundleItemsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListBundleItemsResponse",
  () => [
    { no: 1, name: "items", kind: "message", T: BundleItem, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.CatalogImportReview
 */
export const CatalogImportReview = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CatalogImportReview",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "job_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "product_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "product_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "brand", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 9, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "properties", kind: "message", T: Struct },
    { no: 11, name: "matched_product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "matched_product_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "match_confidence", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 14, name: "destination", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "reject_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "imported_product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "current_price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 18, name: "current_price_currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListImportReviewsRequest
 */
export const ListImportReviewsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListImportReviewsRequest",
  () => [
    { no: 1, name: "job_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page", kind: "message", T: PageRequest },
    { no: 3, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListImportReviewsResponse
 */
export const ListImportReviewsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListImportReviewsResponse",
  () => [
    { no: 1, name: "reviews", kind: "message", T: CatalogImportReview, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.ReviewImportReviewRequest
 */
export const ReviewImportReviewRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ReviewImportReviewRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "action", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "matched_product_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "match_confidence", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.ReviewImportReviewResponse
 */
export const ReviewImportReviewResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ReviewImportReviewResponse",
  () => [
    { no: 1, name: "review", kind: "message", T: CatalogImportReview },
  ],
);

/**
 * @generated from message omnios.v1.BatchReviewImportReviewsRequest
 */
export const BatchReviewImportReviewsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BatchReviewImportReviewsRequest",
  () => [
    { no: 1, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "action", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.BatchReviewImportReviewsResponse
 */
export const BatchReviewImportReviewsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BatchReviewImportReviewsResponse",
  () => [
    { no: 1, name: "updated", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.SearchImportReviewAlternativesRequest
 */
export const SearchImportReviewAlternativesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SearchImportReviewAlternativesRequest",
  () => [
    { no: 1, name: "review_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "query_override", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "attribute_filters", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 4, name: "category_filter", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "include_facets", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.GetSearchIndexStatsRequest
 */
export const GetSearchIndexStatsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetSearchIndexStatsRequest",
  [],
);

/**
 * @generated from message omnios.v1.GetSearchIndexStatsResponse
 */
export const GetSearchIndexStatsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetSearchIndexStatsResponse",
  () => [
    { no: 1, name: "total_indexed", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "with_embeddings", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message omnios.v1.SearchBrandsRequest
 */
export const SearchBrandsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SearchBrandsRequest",
  () => [
    { no: 1, name: "query", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.SearchBrandsResponse
 */
export const SearchBrandsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SearchBrandsResponse",
  () => [
    { no: 1, name: "brands", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.CreatePropertyDefinitionRequest
 */
export const CreatePropertyDefinitionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreatePropertyDefinitionRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "value_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "unit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "is_filterable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "is_required", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "allowed_values", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.UpdatePropertyDefinitionRequest
 */
export const UpdatePropertyDefinitionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdatePropertyDefinitionRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "is_filterable", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 4, name: "is_required", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 5, name: "allowed_values", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "unit", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.GetPropertyDefinitionRequest
 */
export const GetPropertyDefinitionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetPropertyDefinitionRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.DeletePropertyDefinitionRequest
 */
export const DeletePropertyDefinitionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeletePropertyDefinitionRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListPropertyDefinitionsRequest
 */
export const ListPropertyDefinitionsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListPropertyDefinitionsRequest",
  () => [
    { no: 1, name: "category_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListPropertyDefinitionsResponse
 */
export const ListPropertyDefinitionsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListPropertyDefinitionsResponse",
  () => [
    { no: 1, name: "definitions", kind: "message", T: PropertyDefinition, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.SetCategoryPropertiesRequest
 */
export const SetCategoryPropertiesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SetCategoryPropertiesRequest",
  () => [
    { no: 1, name: "category_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "properties", kind: "message", T: CategoryPropertyLink, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.SetCategoryPropertiesResponse
 */
export const SetCategoryPropertiesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SetCategoryPropertiesResponse",
  () => [
    { no: 1, name: "count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.ListCategoryPropertiesRequest
 */
export const ListCategoryPropertiesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListCategoryPropertiesRequest",
  () => [
    { no: 1, name: "category_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListCategoryPropertiesResponse
 */
export const ListCategoryPropertiesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListCategoryPropertiesResponse",
  () => [
    { no: 1, name: "definitions", kind: "message", T: PropertyDefinition, repeated: true },
    { no: 2, name: "links", kind: "message", T: CategoryPropertyLink, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.ImportYandexFeedRequest
 */
export const ImportYandexFeedRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ImportYandexFeedRequest",
  () => [
    { no: 1, name: "feed_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ImportYandexFeedResponse
 */
export const ImportYandexFeedResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ImportYandexFeedResponse",
  () => [
    { no: 1, name: "categories_created", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "products_created", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "products_updated", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "errors", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "feed_shop_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ImportYandexFeedMediaRequest
 */
export const ImportYandexFeedMediaRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ImportYandexFeedMediaRequest",
  () => [
    { no: 1, name: "feed_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ImportYandexFeedMediaResponse
 */
export const ImportYandexFeedMediaResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ImportYandexFeedMediaResponse",
  () => [
    { no: 1, name: "images_downloaded", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "images_linked", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "errors", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.ProcessCatalogImportRequest
 */
export const ProcessCatalogImportRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ProcessCatalogImportRequest",
  () => [
    { no: 1, name: "job_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "media_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "media_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "extraction_mode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "destination", kind: "enum", T: proto3.getEnumType(ImportDestination) },
    { no: 11, name: "competitor_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 12, name: "supplier_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 13, name: "feed_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 14, name: "feed_type", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 15, name: "extraction_model", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.ProcessCatalogImportUpdate
 */
export const ProcessCatalogImportUpdate = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ProcessCatalogImportUpdate",
  () => [
    { no: 1, name: "run_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "step_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "progress_pct", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "data", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.FinalizeCatalogImportRequest
 */
export const FinalizeCatalogImportRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.FinalizeCatalogImportRequest",
  () => [
    { no: 1, name: "job_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "mark_discontinued", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "destination", kind: "enum", T: proto3.getEnumType(ImportDestination) },
    { no: 11, name: "competitor_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 12, name: "supplier_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.FinalizeCatalogImportResponse
 */
export const FinalizeCatalogImportResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.FinalizeCatalogImportResponse",
  () => [
    { no: 1, name: "created", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "updated", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "categories_created", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "properties_created", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "discontinued", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "mapped", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "zero_price", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "price_swings", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "category_misses", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "code_conflicts", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.ProductMapping
 */
export const ProductMapping = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ProductMapping",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "source_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "source_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "external_sku", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "external_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "external_price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 9, name: "external_currency", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "external_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 11, name: "match_confidence", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 12, name: "match_method", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 13, name: "confirmed_by", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 14, name: "confirmed_at", kind: "message", T: Timestamp, opt: true },
    { no: 15, name: "external_product_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 20, name: "product_title", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 21, name: "product_vendor_code", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 30, name: "created_at", kind: "message", T: Timestamp },
    { no: 31, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.SuggestProductMappingsRequest
 */
export const SuggestProductMappingsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SuggestProductMappingsRequest",
  () => [
    { no: 1, name: "source_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "source_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "unmatched_only", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.MappingSuggestion
 */
export const MappingSuggestion = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.MappingSuggestion",
  () => [
    { no: 1, name: "mapping_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "external_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "external_sku", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "suggested_product_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 11, name: "suggested_product_title", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 12, name: "confidence", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 13, name: "match_method", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 20, name: "alternatives", kind: "message", T: MappingCandidate, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.MappingCandidate
 */
export const MappingCandidate = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.MappingCandidate",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "product_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "confidence", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "match_method", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.SuggestProductMappingsResponse
 */
export const SuggestProductMappingsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SuggestProductMappingsResponse",
  () => [
    { no: 1, name: "suggestions", kind: "message", T: MappingSuggestion, repeated: true },
    { no: 2, name: "total_unmatched", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.ConfirmProductMappingRequest
 */
export const ConfirmProductMappingRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ConfirmProductMappingRequest",
  () => [
    { no: 1, name: "mapping_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ConfirmProductMappingResponse
 */
export const ConfirmProductMappingResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ConfirmProductMappingResponse",
  () => [
    { no: 1, name: "mapping", kind: "message", T: ProductMapping },
  ],
);

/**
 * @generated from message omnios.v1.DismissProductMappingRequest
 */
export const DismissProductMappingRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DismissProductMappingRequest",
  () => [
    { no: 1, name: "mapping_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListProductMappingsRequest
 */
export const ListProductMappingsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListProductMappingsRequest",
  () => [
    { no: 1, name: "source_type", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "source_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "unmatched_only", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "page", kind: "message", T: PageRequest },
  ],
);

/**
 * @generated from message omnios.v1.ListProductMappingsResponse
 */
export const ListProductMappingsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListProductMappingsResponse",
  () => [
    { no: 1, name: "mappings", kind: "message", T: ProductMapping, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.BulkConfirmMappingsRequest
 */
export const BulkConfirmMappingsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BulkConfirmMappingsRequest",
  () => [
    { no: 1, name: "mapping_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "min_confidence", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message omnios.v1.BulkConfirmMappingsResponse
 */
export const BulkConfirmMappingsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BulkConfirmMappingsResponse",
  () => [
    { no: 1, name: "confirmed", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.CrossReferenceRequest
 */
export const CrossReferenceRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CrossReferenceRequest",
  () => [
    { no: 1, name: "source_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "source_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "batch_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.CrossRefMatchResult
 */
export const CrossRefMatchResult = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CrossRefMatchResult",
  () => [
    { no: 1, name: "mapping_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "external_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "external_sku", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "external_price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 5, name: "external_currency", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 11, name: "product_title", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 12, name: "product_price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 20, name: "confidence", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 21, name: "method", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 22, name: "triage", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 30, name: "alternatives", kind: "message", T: MappingCandidate, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.CrossReferenceSummary
 */
export const CrossReferenceSummary = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CrossReferenceSummary",
  () => [
    { no: 1, name: "total", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "auto_matched", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "needs_review", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "no_match", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "already_matched", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.CrossReferenceResponse
 */
export const CrossReferenceResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CrossReferenceResponse",
  () => [
    { no: 1, name: "matches", kind: "message", T: CrossRefMatchResult, repeated: true },
    { no: 2, name: "summary", kind: "message", T: CrossReferenceSummary },
  ],
);

/**
 * @generated from message omnios.v1.GetCompetitorInsightsRequest
 */
export const GetCompetitorInsightsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetCompetitorInsightsRequest",
  () => [
    { no: 1, name: "competitor_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.PriceInsight
 */
export const PriceInsight = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PriceInsight",
  () => [
    { no: 1, name: "mapping_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "external_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "external_sku", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "external_price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "external_currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "our_product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "our_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "our_price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 20, name: "price_delta_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 21, name: "price_delta_pct", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 22, name: "position", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 30, name: "match_confidence", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 31, name: "match_method", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CompetitorInsightsSummary
 */
export const CompetitorInsightsSummary = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CompetitorInsightsSummary",
  () => [
    { no: 1, name: "competitor_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "competitor_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "total_mapped", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "total_with_price", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "cheaper_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "same_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "pricier_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "avg_delta_pct", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "median_delta_pct", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 10, name: "attention_needed", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.GetCompetitorInsightsResponse
 */
export const GetCompetitorInsightsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetCompetitorInsightsResponse",
  () => [
    { no: 1, name: "summary", kind: "message", T: CompetitorInsightsSummary },
    { no: 2, name: "insights", kind: "message", T: PriceInsight, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.SearchSynonym
 */
export const SearchSynonym = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SearchSynonym",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "synonym_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "root_word", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "words", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "created_at", kind: "message", T: Timestamp },
    { no: 7, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.CreateSearchSynonymRequest
 */
export const CreateSearchSynonymRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateSearchSynonymRequest",
  () => [
    { no: 1, name: "synonym_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "root_word", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "words", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.UpdateSearchSynonymRequest
 */
export const UpdateSearchSynonymRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateSearchSynonymRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "synonym_type", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "root_word", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "words", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.DeleteSearchSynonymRequest
 */
export const DeleteSearchSynonymRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteSearchSynonymRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListSearchSynonymsRequest
 */
export const ListSearchSynonymsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListSearchSynonymsRequest",
  [],
);

/**
 * @generated from message omnios.v1.ListSearchSynonymsResponse
 */
export const ListSearchSynonymsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListSearchSynonymsResponse",
  () => [
    { no: 1, name: "synonyms", kind: "message", T: SearchSynonym, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.SearchSettings
 */
export const SearchSettings = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SearchSettings",
  () => [
    { no: 1, name: "num_typos", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "typo_tokens_threshold", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "stemming_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "stemming_locale", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetSearchSettingsRequest
 */
export const GetSearchSettingsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetSearchSettingsRequest",
  [],
);

/**
 * @generated from message omnios.v1.UpdateSearchSettingsRequest
 */
export const UpdateSearchSettingsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateSearchSettingsRequest",
  () => [
    { no: 1, name: "num_typos", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 2, name: "typo_tokens_threshold", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 3, name: "stemming_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 4, name: "stemming_locale", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.SyncSearchSynonymsRequest
 */
export const SyncSearchSynonymsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SyncSearchSynonymsRequest",
  [],
);

/**
 * @generated from message omnios.v1.SyncSearchSynonymsResponse
 */
export const SyncSearchSynonymsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SyncSearchSynonymsResponse",
  () => [
    { no: 1, name: "synced", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * CSV format: words (required), root_word (optional), type (optional)
 * For multi-way: words column contains comma-separated equivalent terms
 * For one-way: root_word is the search term, words are the synonyms
 * Synonyms are applied to products collection only
 *
 * @generated from message omnios.v1.ImportSearchSynonymsRequest
 */
export const ImportSearchSynonymsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ImportSearchSynonymsRequest",
  () => [
    { no: 1, name: "csv_data", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 2, name: "replace_existing", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.ImportSearchSynonymsResponse
 */
export const ImportSearchSynonymsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ImportSearchSynonymsResponse",
  () => [
    { no: 1, name: "imported", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "skipped", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "errors", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.EnrichProductRequest
 */
export const EnrichProductRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.EnrichProductRequest",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "force", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.EnrichProductResponse
 */
export const EnrichProductResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.EnrichProductResponse",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "quality_score", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "enrichment_version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.GetEnrichmentStatsRequest
 */
export const GetEnrichmentStatsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetEnrichmentStatsRequest",
  [],
);

/**
 * @generated from message omnios.v1.GetEnrichmentStatsResponse
 */
export const GetEnrichmentStatsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetEnrichmentStatsResponse",
  () => [
    { no: 1, name: "total_products", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "enriched_products", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "pending_enrichment", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "avg_quality_score", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 10, name: "quality_0_25", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 11, name: "quality_26_50", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 12, name: "quality_51_75", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 13, name: "quality_76_100", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 20, name: "title_rules_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 21, name: "brand_aliases_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 22, name: "category_centroids_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 23, name: "category_patterns_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.GetProductEnrichmentHistoryRequest
 */
export const GetProductEnrichmentHistoryRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetProductEnrichmentHistoryRequest",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.EnrichmentHistoryEntry
 */
export const EnrichmentHistoryEntry = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.EnrichmentHistoryEntry",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "stage", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "mode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "confidence", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 6, name: "result", kind: "message", T: Struct },
    { no: 7, name: "created_at", kind: "message", T: Timestamp },
    { no: 8, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.GetProductEnrichmentHistoryResponse
 */
export const GetProductEnrichmentHistoryResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetProductEnrichmentHistoryResponse",
  () => [
    { no: 1, name: "entries", kind: "message", T: EnrichmentHistoryEntry, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.ExportCatalogRequest
 */
export const ExportCatalogRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ExportCatalogRequest",
  () => [
    { no: 1, name: "include_embeddings", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "include_enrichment_state", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "include_compliance", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.ExportCatalogResponse
 */
export const ExportCatalogResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ExportCatalogResponse",
  () => [
    { no: 1, name: "download_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "expires_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "stats", kind: "message", T: ExportStats },
  ],
);

/**
 * @generated from message omnios.v1.ExportStats
 */
export const ExportStats = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ExportStats",
  () => [
    { no: 1, name: "categories", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "property_definitions", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "category_properties", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "products", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "enrichment_states", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "compliance_links", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "embeddings", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.ImportCatalogRequest
 */
export const ImportCatalogRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ImportCatalogRequest",
  () => [
    { no: 1, name: "download_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "overwrite", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "data", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 4, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ImportCatalogResponse
 */
export const ImportCatalogResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ImportCatalogResponse",
  () => [
    { no: 1, name: "stats", kind: "message", T: ImportStats },
    { no: 2, name: "errors", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.ImportStats
 */
export const ImportStats = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ImportStats",
  () => [
    { no: 1, name: "categories_created", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "categories_updated", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "property_definitions_created", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "property_definitions_updated", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "products_created", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "products_updated", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "products_skipped", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "enrichment_states_restored", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "compliance_links_restored", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "embeddings_restored", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.CustomerPricingRule
 */
export const CustomerPricingRule = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CustomerPricingRule",
  () => [
    { no: 1, name: "customer_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "default_margin_pct", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "category_overrides", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 1 /* ScalarType.DOUBLE */} },
    { no: 4, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetCustomerPricingRuleRequest
 */
export const GetCustomerPricingRuleRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetCustomerPricingRuleRequest",
  () => [
    { no: 1, name: "customer_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.SetCustomerPricingRuleRequest
 */
export const SetCustomerPricingRuleRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SetCustomerPricingRuleRequest",
  () => [
    { no: 1, name: "rule", kind: "message", T: CustomerPricingRule },
  ],
);

/**
 * @generated from message omnios.v1.PreviewCustomerPricingRequest
 */
export const PreviewCustomerPricingRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PreviewCustomerPricingRequest",
  () => [
    { no: 1, name: "customer_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "product_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.PricedProduct
 */
export const PricedProduct = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PricedProduct",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "cost_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "cost_currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "margin_pct", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.PreviewCustomerPricingResponse
 */
export const PreviewCustomerPricingResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PreviewCustomerPricingResponse",
  () => [
    { no: 1, name: "items", kind: "message", T: PricedProduct, repeated: true },
  ],
);

